/**
 * <s-ship-date> — swaps a static dispatch promise for a live "Ships by <date>".
 *
 * The date is today plus the lead time in business days, skipping Saturday and
 * Sunday, formatted in the page language. Without JavaScript the server text
 * (for example "Ships in 24 hours") stays in place.
 *
 * Attributes:
 *   data-lead-days — business days until dispatch (default 1).
 *   data-label     — translated label containing __DATE__ where the date goes.
 */
class SShipDate extends HTMLElement {
  connectedCallback() {
    const label = this.dataset.label;
    if (!label || !label.includes('__DATE__')) return;

    const leadDays = Math.max(0, Number(this.dataset.leadDays ?? 1));
    const date = new Date();
    let added = 0;
    while (added < leadDays) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    // A zero lead time on a weekend still rolls to Monday.
    while (date.getDay() === 0 || date.getDay() === 6) {
      date.setDate(date.getDate() + 1);
    }

    const formatted = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    }).format(date);

    this.textContent = label.replace('__DATE__', formatted);
  }
}

if (!customElements.get('s-ship-date')) {
  customElements.define('s-ship-date', SShipDate);
}
